import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerDataRouterApp, registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'
import {commitsAppBuilder} from './config/app-builder'
import {
  CommitEntrypoint,
  CommitEntrypointFuture,
  CommitFragmentEntrypointFuture,
  CommitPathEntrypointFuture,
} from './routes/Commit'
import {commitFragmentRoute} from './routes/commit-fragment-route'
import {commitPathRoute} from './routes/commit-path-route'
import {commitRoute} from './routes/commit-route'
import {CommitsEntrypoint, CommitsEntrypointFuture, CommitsRefEntrypointFuture} from './routes/Commits'
import {commitsLayoutRoute} from './routes/commits-layout-route'
import {commitsRefRoute} from './routes/commits-ref-route'
import {commitsRoute} from './routes/commits-route'
import {CommitsLayout} from './routes/CommitsLayout'

registerNavigatorApp('commits', () => ({
  App,
  routes: [
    jsonRoute({path: '/:owner/:repo/commits', Component: CommitsEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commits/:ref', Component: CommitsEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commits/:ref/:path/*', Component: CommitsEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commit/:oid', Component: CommitEntrypoint}),
    jsonRoute({path: '/:owner/:repo/commit/:oid/:path/*', Component: CommitEntrypoint}),
    jsonRoute({
      path: '/_view_fragments/Voltron::CommitFragmentsController/show/:owner/:repo/:name/repo_layout',
      Component: CommitEntrypoint,
    }),
  ],
}))

export const commitsApp = commitsAppBuilder.createDataRouterAppFromRoutes([
  commitsLayoutRoute.toRoute({
    Component: CommitsLayout,
    children: [
      commitsRoute.toRoute({Component: CommitsEntrypointFuture}),
      commitsRefRoute.toRoute({Component: CommitsRefEntrypointFuture}),
      commitRoute.toRoute({Component: CommitEntrypointFuture}),
      commitPathRoute.toRoute({Component: CommitPathEntrypointFuture}),
    ],
  }),
  // Served under `/_view_fragments`, so it cannot nest under the repo-scoped layout. The backend
  // sends the canonical commit path as the initial path, so this only matches legacy renders.
  commitFragmentRoute.toRoute({Component: CommitFragmentEntrypointFuture}),
])
registerDataRouterApp(commitsApp)
